(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});

	initProductAccordion();
})();

/* CUSTOM - Globo Product Options listener with delegation */

// function handleGPOChange(event) {
//   const input = event.target;

//   if (!input.closest('.gpo-element')) return;
//   if (input.type !== 'checkbox' && input.type !== 'radio') return;

//   const gpoElement = input.closest('.gpo-element');

//   // Array to hold selected options and their prices
//   const selectedOptions = [];

//   // Loop over all checked inputs inside this GPO element
//   gpoElement.querySelectorAll('input:checked').forEach(checkedInput => {
//     const choiceDiv = checkedInput.closest('.gpo-choicelist');
//     if (!choiceDiv) return;

//     const optionTextEl = choiceDiv.querySelector('.choicelist-item__value');
//     const helpTextEl = choiceDiv.querySelector('.gpo-ov-helptext');

//     const optionText = optionTextEl ? optionTextEl.textContent.trim() : checkedInput.value;
//     const priceText = helpTextEl ? helpTextEl.textContent.trim() : null;

//     // Parse the price string into a number
//     let priceNumber = null;
//     if (priceText) {
//       // Remove currency symbols, commas, etc.
//       priceNumber = parseFloat(priceText.replace(/[^0-9.]/g, ''));
//     }

//     selectedOptions.push({
//       text: optionText,
//       price: priceNumber
//     });
//   });

// //   console.log(`GPO Element ID: ${gpoElement.dataset.elementId}`);
//   console.log('Selected Options with Price:', selectedOptions);
// }

// // Attach listener
// document.body.addEventListener('change', handleGPOChange);